import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "popular-game" };
const _hoisted_2 = { class: "overlay pt-32 pb-120" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row wow fadeInUp" };
const _hoisted_5 = { class: "single-box" };
const _hoisted_6 = ["href"];
const _hoisted_7 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "abs-item" }, [
                _createElementVNode("img", {
                    src: "/assets/images/popular-game-item.png",
                    alt: "icon"
                })
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.providers, (provider) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: provider.id,
                            class: "col-lg-4 col-md-4 col-lg-3 col-xl-5th"
                        }, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("a", {
                                        href: $setup.user?.username ? `${$setup.Const.URL}/game/${provider.name}/?api_exit=/` : undefined,
                                        target: "_blank",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (!$setup.user?.username && $event.preventDefault()))
                                    }, [
                                        _createElementVNode("img", {
                                            src: `${$setup.Const.URL}/frontend/Default/img/providers/${provider.name}.png`,
                                            alt: provider.title
                                        }, null, 8, _hoisted_7)
                                    ], 8, _hoisted_6)
                                ])
                            ])
                        ]));
                    }), 128))
                ])
            ])
        ])
    ]));
}
